import { supabase } from '@/integrations/supabase/client';

/**
 * Check if the current user has admin privileges.
 * Queries the profiles table for role='admin' — no hardcoded email lists.
 */
export async function checkIsAdmin(userId: string): Promise<boolean> {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('role')
      .eq('id', userId)
      .single();

    if (error || !data) return false;
    return data.role === 'admin';
  } catch {
    return false;
  }
}
